<div class="center-box">
    <div class="middle">
        <div><img src="assets/img/logo.png"></div>
        <div style="text-align: center;margin-top: 10px;">loading ...</div>
    </div>
</div>
<!-- Modal -->
<div class="popup" *ngIf="wifiModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">

                <h3 class="modal-title modal-title-color">Please use your Safaricom Internet to access this service.
                </h3>

            </div>
        </div>
    </div>
</div>